import HttpFactory from "~/repository/factory";
import type {
  SchoolNotificationDetail,
  SchoolNotificationFilters,
  SchoolNotificationPage,
} from "~/types/schoolNotifications";

const base = "/api/organizations/current/notifications/";

export default class SchoolNotificationsModule extends HttpFactory {
  list(filters: SchoolNotificationFilters = {}) {
    return this.get<SchoolNotificationPage>(base, filters);
  }

  getNotification(id: string) {
    return this.get<SchoolNotificationDetail>(
      `${base}${encodeURIComponent(id)}/`,
    );
  }
}
